@use "Styles/mixins";
@use "Styles/includes/variables";

:host {
    display: block;
    font-family: variables.$fontQuaternary;
}

.vm-video-hub-card {
    &__logo {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: inline-block;

        border: 1px solid;
        border-color: mixins.get-color(border, solid, disabled);

        &::part(image) {
            object-position: unset;
        }
    }

    &__title {
        font-size: mixins.get-font-size(text-sm);
        line-height: mixins.get-line-height(text-sm);
        color: mixins.get-color(text, text-secondary);

        @include mixins.desktop-and-up() {
            font-weight: 900;
        }
    }

    &__cta {
        background: mixins.get-color(background, bg-white);
        border-radius: 50px;
    }
}
